import { t } from "i18next";
import { z } from "zod";

export const collectorSchema = z.object({
  id: z.string().optional(),
  collectionneursDescriptionNom: z
    .string()
    .nonempty(t("form.error.emptyField")),
  collectionneursDescriptionPrenom: z.string(),
});
